import type { TempSortCountSessionDTO } from '../types/sortAndCount';

const STORAGE_KEY = 'TEMP_SORT_COUNT_SESSIONS_V1';

const loadAll = (): TempSortCountSessionDTO[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const saveAll = (sessions: TempSortCountSessionDTO[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(sessions) ? sessions : []));
};

export const listTempSortCountSessions = (): TempSortCountSessionDTO[] => {
  return loadAll().sort((a, b) => String(b?.updated_at || '').localeCompare(String(a?.updated_at || '')));
};

export const getTempSortCountSession = (id: string): TempSortCountSessionDTO | null => {
  const safeId = String(id || '').trim();
  if (!safeId) return null;
  return loadAll().find((session) => String(session?.id || '') === safeId) || null;
};

export const upsertTempSortCountSession = (session: TempSortCountSessionDTO): TempSortCountSessionDTO => {
  const all = loadAll();
  const safeId = String(session?.id || '').trim();
  if (!safeId) throw new Error('session id is required');
  const now = new Date().toISOString();
  const payload: TempSortCountSessionDTO = {
    ...session,
    id: safeId,
    updated_at: now,
    created_at: String(session?.created_at || now),
    name: String(session?.name || '').trim() || '临时分拣清点会话',
  };
  const idx = all.findIndex((item) => String(item?.id || '') === safeId);
  if (idx >= 0) {
    all[idx] = payload;
  } else {
    all.unshift(payload);
  }
  saveAll(all);
  return payload;
};

export const removeTempSortCountSession = (id: string): void => {
  const safeId = String(id || '').trim();
  if (!safeId) return;
  saveAll(loadAll().filter((session) => String(session?.id || '') !== safeId));
};

